<template>
  <div class="container">
    <div id="page1-div" class="container interline border page-container">
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-4 pb-3">
          <u class="ft12Black"> CONTRATO COMPRAVENTA DE VEHÍCULO<br /> </u>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft12">
            En
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span
            >,<span v-bind:class="{ marca: data.showMarca }" class="ft12Black">
              {{ data.estado_cliente }}</span
            >; a las ______, del
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }} </span
            >; estando presentes el ________________________________, a quien
            en lo sucesivo y para efectos del presente contrato se le denominará
            <span class="ft12Black"> “EL VENDEDOR”</span> y por la otra parte,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_cliente }}</span
            >
            , a quien en adelante se le denominará <span class="ft12Black"> “EL COMPRADOR”</span>, quienes de
            conformidad convienen en celebrar el presente contrato de
            <span class="ft12Black">COMPRAVENTA </span>al tenor de las siguientes:<br />
          </span>
          <div class="col-12 text-center">
            <span class="ft13Black"> <br />DECLARACIONES <br /><br /> </span>
          </div>
          <span class="ft12 text-justify">
            <span class="ft12Black">PRIMERA. - “EL VENDEDOR”</span>, confirma
            ser mayor de edad, con domicilio en ____________________________________________________________________,
            identificándose con credencial para votar, expedida por el Instituto Nacional Electoral, con número de clave de elector
            _____________________________________.
          </span>
          <br /><br />
          <span class="ft12 text-justify">
            <span class="ft12Black">SEGUNDA. - “EL COMPRADOR”, </span>confirma
            ser mayor de edad, con domicilio en  
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.calle_cliente }},
            </span>
            No.
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_calle_cliente }}
            </span>
            COLONIA
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.colonia_cliente }}</span
            >, CODIGO POSTAL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.codigo_postal_cliente }}</span
            >, DE LA POBLACION DE
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span
            >,
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.estado_cliente }}, </span
            >  identificándose con credencial
            para votar, expedida por el Instituto Nacional Electoral, con número
            de clave de elector.
             <br /><br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">TERCERA.-“EL VENDEDOR”, </span>confirma que
            es el actual propietario del vehículo materia de la presente
            compraventa, de conformidad con la factura número expedida
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }},
            </span>
            emitida por
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura }},
            </span>
            a nombre de ___________________________________, con las siguientes
            características: Marca
            <span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.marca_vehiculo }} </span
            >, Modelo
            <span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.modelo_vehiculo }} </span
            >, Color Exterior, ___________, Color Interior, __________; Número
            de Serie
            <span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.numero_serie_vehiculo.toUpperCase() }} </span
            >, Número de Motor
            <span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.numero_motor_vehiculo.toUpperCase() }} </span
            >, Placas de Circulación,___________, Tarjeta de
            Circulación,_____________________, Número De Puertas, ________.
            <br /><br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">CUARTA. </span>- Ambas partes manifiestan y
            se reconocen entre sí, tener la capacidad jurídica para celebrar el
            presente contrato. <br /><br />
          </span>
          <div class="col-12 text-center">
            <span class="ft13Black">
              <br />OBJETO DEL CONTRATO<br /><br />
            </span>
          </div>
        </div>
        <span class="ft12 text-justify">
          Es objeto del presente contrato, es la compraventa del vehículo citado
          en la declaración TERCERA del presente contrato, con las
          características y particularidades señaladas. <br /><br />
        </span>
        <span class="ft12 text-justify">
          Por lo expuesto, y con fundamento en las disposiciones legales antes
          citadas, y por así convenir a sus intereses, es deseo y voluntad de
          las partes contratantes celebrar el presente contrato, sujetándose a
          las siguientes: <br /><br />
        </span>
        <div class="col-12 text-center">
          <span class="ft13Black"> <br />CLAUSULAS<br /><br /> </span>
        </div>
        <span class="ft12 text-justify">
          <span class="ft12Black">PRIMERA.</span> El C.
          _________________________________ transmite la propiedad a través del
          presente contrato al C.
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.nombre_cliente }}</span
          >, quien adquiere para sí el vehículo descrito en la declaración
          TERCERA del presente instrumento. <br /><br />
        </span>
        <span class="ft12 text-justify">
          <span class="ft12Black"> SEGUNDA.</span> “EL COMPRADOR”, manifiesta su
          conformidad de las condiciones físicas y mecánicas en las que se
          encuentra el vehículo al momento de la operación de compraventa, por
          lo que a partir de la fecha de entrega del vehículo objeto de este
          contrato, los desperfectos que pudieran presentarse con posterioridad
          no darán lugar a reclamación alguna. <br /><br />
        </span>
        <span class="ft12 text-justify">
          <span class="ft12Black">TERCERA.</span> El precio de compraventa del
          vehículo es de _____________________________________________, el cual
          ha sido cubierto en su totalidad por “EL COMPRADOR” con anterioridad a
          la firma del presente Contrato.<br /><br />
        </span>
        <span class="ft12 text-justify">
          <span class="ft12Black">CUARTA.</span> “EL COMPRADOR”, manifiesta su
          aceptación en el valor del vehículo y “EL VENDEDOR” la forma de pago
          expresada en la cláusula anterior. Esta unidad es usada y se vende en
          las condiciones en que se encuentra de motor, transmisión, suspensión
          y hojalatería.<br /><br />
        </span>
        <span class="ft12 text-justify">
          <span class="ft12Black">QUINTA.</span> “EL VENDEDOR”, manifiesta que
          el vehículo objeto del presente contrato mismo que se describe en la
          Declaración TERCERA del presente instrumento, se encuentra libre de
          gravámenes y al corriente en el pago de los impuestos y derechos de
          control vehicular señalados en la misma declaración TERCERA; por lo
          que a la firma del presente Contrato se entregan los comprobantes de
          pago descritos y demás documentación señalada, toda relacionada con el
          vehículo. <br /><br />
        </span>
      </div>
    </div>
    <div id="page2-div" class="container interline border page-container">
      <div class="col-12 p-4">
        <div class="col-12 text-justify pt-4">
          <span class="ft12 text-justify">
            <span class="ft12Black"> SEXTA.</span> “EL VENDEDOR”, hace entrega
            física y jurídica del vehículo materia del presente contrato, el día
            ______________________ y “EL COMPRADOR”, después de haber revisado
            por cuenta propia el vehículo, lo recibe de conformidad y así como
            la siguiente documentación: <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp; i) Factura número
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }},
            </span>
            emitida por
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura }},
            </span>
            a nombre del C. , respecto del  &emsp;&emsp; &emsp;&emsp;Vehículo materia del presente
            contrato con las siguientes características descritas en la
            declaración Tercera; <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp;ii) Copia de la factura de origen número ______________, relacionada
            con el mismo vehículo, expedida por  &emsp;&emsp; &emsp;&emsp;&emsp;&emsp; &emsp;&emsp;_____________________________, a
            nombre del C. ___________________________, de fecha
            &emsp;&emsp; &emsp;&emsp;&emsp;&emsp; &emsp;&emsp; &emsp;&emsp; &emsp;&emsp;___________________________; <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp;iii) Copia de la factura de origen número ______________,
            relacionada con el mismo vehículo, expedida por 
            &emsp;&emsp; &emsp;&emsp;&emsp;&emsp; &emsp;&emsp; ________________________, a nombre del C.
            ___________________________, de fecha ________________________;
            <br /><br />
          </span>
          <span class="ft12 text-justify">  &emsp;&emsp;iv) ……….. <br /><br /> </span>
          <span class="ft12 text-justify">
            &emsp;&emsp; v) Recibos de pago del Impuesto Sobre Tenencia (refrendo) por los
            ejercicios fiscales ________________; <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp; vi) Manual para el Propietario; <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp;vii) Constancia de verificación, <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp; viii) Tarjeta de Circulación, __________________ del año _________,
            <br /><br />
          </span>
          <span class="ft12 text-justify">
            &emsp;&emsp; ix) Otros documentos. <br /><br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">SÉPTIMA.</span> “EL VENDEDOR”, con motivo de
            la celebración del presente contrato, cede los derechos que se
            deriven de la adquisición del vehículo citado en la declaración
            TERCERA del presente contrato, al “COMPRADOR” en todo lo que de
            hecho y por derecho le corresponda y éste adquiere las obligaciones
            inherentes a dicho vehículo.
            <br /> <br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">OCTAVA.</span> “EL COMPRADOR”, a partir de
            la fecha de entrega del vehículo, será responsable de mantener al
            corriente los impuestos y derechos de control vehicular que devengue
            del mismo y se obliga a realizar el trámite de cambio de propietario
            ante la autoridad fiscal correspondiente, dentro de los 15 días
            hábiles siguientes a la suscripción del presente Contrato.
            <br /> <br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">NOVENA.</span> “EL VENDEDOR”, se deslinda de
            cualquier responsabilidad civil o penal que pudiera resultar por el
            uso, manejo o funcionamiento del vehículo materia del presente
            contrato a partir de la fecha de entrega de este. En consecuencia,
            en términos del artículo 7.366 del Código Civil del Estado de
            México, “EL VENDEDOR” Responde del saneamiento para el caso de
            evicción.
            <br /> <br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">DÉCIMA. </span> Ambas partes, en términos
            del artículo 7.52 del Código Civil del Estado de México, manifiestan
            que, en la celebración del presente contrato, no existe error, dolo,
            violencia o mala fe que pudiera invalidarlo.
            <br /> <br />
          </span>
          <span class="ft12 text-justify">
            <span class="ft12Black">DÉCIMA PRIMERA.</span> Para todo lo relativo
            a la interpretación y cumplimiento de las obligaciones derivadas del
            presente contrato, las partes acuerdan someterse a la jurisdicción y
            competencia de los tribunales de Naucalpan estado de México,
            renunciando a cualquier otra jurisdicción que les pudiera
            corresponder por razón de domicilio, vecindad, o cualquier otra
            naturaleza.
            <br /> <br />
          </span>
          <span class="ft12 text-justify">
            Previa lectura del contenido del presente contrato, las partes
            aceptan quedar obligadas en todos sus términos y condiciones, las
            cuales se constituyen en expresión completa y exclusiva de su
            voluntad libre de cualquier vicio, y lo firman de conformidad en dos
            tantos, siendo las once horas de la fecha y lugar señalado en el
            proemio del presente contrato.
            <br /> <br />
          </span>
        <div class="col-12 row  pt-4 ">
          <div class="col-5 offset-1 text-center border-bottom  pt-4 pb-5">
            <span class="ft11">
              “EL COMPRADOR”
            </span>
          </div>
          <div class="col-5 text-center border-bottom  pt-4 pb-5">
            <span class="ft11">
              “EL VENDEDOR”
            </span>
          </div>
        </div>
        <div class="col-12 row pb-5">
          <div class="col-5 offset-1 text-center border-bottom pt-4 pb-5">
            <span class="ft11">
              TESTIGO
            </span>
          </div>
          <div class="col-5 text-center border-bottom pt-4 pb-5">
            <span class="ft11">
              TESTIGO
            </span>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/Carta_contrato_compraventa.vue